import { Component, OnInit } from "@angular/core";
import { Product } from "../../models/product";
import { ProductService } from "../../services/product.service";
import { ActivatedRoute, Router } from "@angular/router";
// for cart
import { UNITS, Price } from "../../models/price";
import { Item } from "../../models/item";
import { Quantity } from "../../models/quantity";
import { CartService } from "../../services/cart.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.scss"],
})
export class ProductsComponent implements OnInit {
  products: Product[] = new Array();
  tags: Product[] = new Array();
  topProducts: Product[] = new Array();
  currentProducts: Product[] = new Array();
  categories: string[] = new Array();
  currentCategory = "all";
  maxProducts: number = 9;
  numberPages: number = 1;
  currentPage: number = 1;
  searchString = "";

  // for cart
  keyUp = "";
  quant: number = 1;
  chosenUnit: string = UNITS[0].name;

  constructor(
    private productService: ProductService,
    private cartService: CartService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let category: string = params["category"];
      this.currentCategory = category;
    });
    this.setCategory(this.currentCategory);
    // this.topProducts = this.getTopProducts();
    this.tags = this.productService.findRandomAndExcludeMany(
      4,
      this.topProducts
    );
    // this.currentProducts = this.productService.slice(this.currentProducts, ((this.currentPage - 1) * this.maxProducts), this.currentPage * this.maxProducts)
    this.setCategories();
  }

  addToCart(product) {
    this.chosenUnit = product.prices[0].unit;
    if (this.keyUp) this.quant = parseFloat(this.keyUp);
    if (this.chosenUnit && Number.isFinite(this.quant) && !(this.quant <= 0)) {
      let item: Item = new Item();
      let quant: Quantity = new Quantity();
      quant.quantity = this.quant;
      quant.unit = this.chosenUnit;
      item.product = product;
      item.quantity = quant;
      this.cartService.add(item);
    } else {
      this.quant = 1;
      Swal({
        title: "Bad Quantity",
        text: "Please enter a non zero quantity value to proceed",
        type: "warning",
        confirmButtonText: "Ok got it!",
        confirmButtonColor: "#07a763",
      });
    }
  }

  getCategory(category: string): boolean {
    return this.currentCategory === category ? true : false;
  }

  setCategory(category: string) {
    if (category.toLowerCase() === "all") {
      // this.currentProducts = this.products
      this.route.params.subscribe((params) => {
        let page: number = params["page"];
        let category: string = params["category"];
        this.currentCategory = category;
        this.currentPage = page;
        let allProducts = this.productService.findAllCategories();
        this.numberPages = Math.ceil(allProducts.length / this.maxProducts);
        if (this.currentPage < 1 || this.currentPage > this.numberPages) {
          this.router.navigate(["/"]);
        }
        this.products = this.productService.findAllCategories();
      });
      this.currentProducts = this.productService.slice(
        this.products,
        (this.currentPage - 1) * this.maxProducts,
        this.currentPage * this.maxProducts
      );
      this.currentProducts.sort((a, b) => a.name.localeCompare(b.name));
      this.currentCategory = category;
    } else {
      this.route.params.subscribe((params) => {
        let page: number = params["page"];
        let category: string = params["category"];
        this.currentCategory = category;
        this.currentPage = page;
        let allProducts = this.productService
          .findAllCategories()
          .filter((p) => p.category.toLowerCase() === category.toLowerCase());
        this.numberPages = Math.ceil(allProducts.length / this.maxProducts);
        if (this.currentPage < 1 || this.currentPage > this.numberPages) {
          this.router.navigate(["/"]);
        }
        this.currentProducts = new Array();
        this.currentProducts = this.productService.slice(
          allProducts,
          (this.currentPage - 1) * this.maxProducts,
          this.currentPage * this.maxProducts
        );
      });
      this.currentProducts.sort((a, b) => a.name.localeCompare(b.name));
      this.currentCategory = category;
    }
  }

  search() {
    if (this.searchString !== "") {
      this.router.navigate(["search/" + this.searchString.replace(" ", "+")]);
    }
  }

  getPagesArray() {
    let pages = this.numberPages;
    return Array(pages)
      .fill(1)
      .map((x, i) => i + 1);
  }

  // getProductStars(product: Product) {
  //   let stars = 0;
  //   if (product.comments.length <= 0) {
  //     return product.stars;
  //   } else {
  //     for (var i = 0; i < product.comments.length; i++) {
  //       stars += product.comments[i].stars;
  //     }
  //     if (stars > 100) {
  //       return 90;
  //     } else {
  //       return Math.ceil(stars / product.comments.length);
  //     }
  //   }
  // }

  getCategroyCount(category: string) {
    let count = 0;
    if (category.toLowerCase() === "all") {
      count = this.productService.findAllCategories().length;
    } else {
      this.productService.findByCategory(category).forEach((product) => {
        if (product.category.toLowerCase() === category.toLowerCase()) {
          count++;
        }
      });
    }
    return count;
  }

  // getTopProducts() {
  //   let products: Product[] = [];
  //   this.productService.findAllCategories().forEach((p) => {
  //     if (p.stars >= 80 && products.length <= 3) {
  //       products.push(p);
  //     }
  //   });
  //   return products;
  // }

  setCategories() {
    this.productService.findAll().forEach((p) => {
      if (
        !this.categories.includes(p.category.toLowerCase()) &&
        p.category != ""
      ) {
        this.categories.push(p.category.toLowerCase());
      }
    });
  }
}
